const getSupplierPhone1 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business['Company Contact'] && business['Company Contact']['Phone Number']
    ? business['Company Contact']['Phone Number'].replace('+1 ', '').replace(/[\s()-]/g, '').slice(0, 3) : null;
};

export default getSupplierPhone1;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierPhone1.js